<template>
  <div>
    <div class="footer">
      <p class="linkText">
        <span class="noLine">法律声明</span>
        <span class="text_item">隐私保护</span>
        <span class="text_item">惩防系统</span>
        <span class="text_item">意见反馈</span>
        <span class="text_item">投诉举报</span>
      </p>
      <!-- <p class="linkText">
        <span class="noLine">深圳市益安保理有限公司@版权所有</span>
        <span class="text_item">粤ICP备**************号</span>
        <span class="text_item">粤公网安备 ************************号</span>
      </p>-->
      <p class="linkText">
        <a href="http://www.beian.miit.gov.cn/">备案号：粤ICP备19061307号</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
}
</script>
<style lang="stylus" scoped>
.footer
  position relative
  bottom 0px
  width 100%
  height 100px
  background-color #666666
  padding-top 30px
  .linkText
    color #CCCCCC
    text-align center
    .noLine
      display inline-block
      text-align center
      margin 0 20px
    .text_item
      display inline-block
      text-align center
      margin 0 20px
      &:after
        content ""
        position relative
        top -12px
        right 20px
        display block
        width 1px
        height 12px
        background #CCCCCC

</style>
